import { MODE_INFO, MODE_INFO_COPY, SETUP_CHOICES, modeInfoLabel } from "../lib/eam";
import InfoTip from "./InfoTip";

/** The For/Against tip of one setup choice. */
export default function ModeInfoTip({ id }: { id: (typeof SETUP_CHOICES)[number]["id"] }) {
  const choice = SETUP_CHOICES.find((c) => c.id === id) ?? SETUP_CHOICES[0];
  return (
    <InfoTip label={modeInfoLabel(choice.title)}>
      <p>
        <b>{MODE_INFO_COPY.for}</b> {MODE_INFO[id].for}
      </p>
      <p className="mt-2">
        <b>{MODE_INFO_COPY.against}</b> {MODE_INFO[id].against}
      </p>
    </InfoTip>
  );
}
